export default __webpack_public_path__ + "static/media/person.8b82d7a0.svg";